export default "__VITE_ASSET__0k4sjOFS__"